module.exports = __webpack_public_path__ + "img/热度.2098188b.svg";